module.exports = __webpack_public_path__ + "static/media/internetError.db06013b.gif";